import { render, staticRenderFns } from "./EntitiesPage.vue?vue&type=template&id=cb80f1cc&"
import script from "./EntitiesPage.vue?vue&type=script&lang=js&"
export * from "./EntitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports